import * as Yup from 'yup'

export const validationSchema = Yup.object({
    reportId: Yup.string().required('Report Id field is required'),
    clientId: Yup.string().required('Client Id field is required'),
    workspaceId: Yup.string().required('Workspace Id field is required'),
    tenantId: Yup.number().required('Tenant Id field is required'),
    entityId: Yup.string().required('Entity Id field is required'),
    clientSecret: Yup.string().required('Client Secret field is required')
})